import React from 'react';
import PropTypes from 'prop-types';
import { Select } from '@knockrentals/knock-shared-web-v2';
import { makeCss } from '../../../../../../../../knock-design-system';
import { TIME_OPTIONS } from './timeOptions';

const useCss = makeCss({
  root: {
    width: '100%',
    minWidth: 0,
    flex: 1,

    '& > .MuiFormControl-root': {
      width: '100%',
    },
  },
});

const HoursTimeSelect = ({
  ariaLabel,
  disabled,
  label,
  onChange,
  value,
}) => {
  const css = useCss();

  return (
    <div css={css.root}>
      <Select
        aria-label={ariaLabel}
        disabled={disabled}
        fullWidth
        label={label}
        onChange={onChange}
        options={TIME_OPTIONS}
        value={value}
        variant="outlined"
      />
    </div>
  );
};

HoursTimeSelect.propTypes = {
  ariaLabel: PropTypes.string,
  disabled: PropTypes.bool,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
};

export default HoursTimeSelect;
